export const MAX_RGB = 255

export const LUMINANCE_ADD = 0.05

export const NUMERIC_VALUES = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SIXTEEN: 16
}

export const CHANNEL = {
  CONDITION: 0.03928,
  FIRST_DIVISOR: 12.92,
  SECOND_DIVISOR: 1.055,
  ADD: 0.055,
  MULTIPLIER: 2.4
}

export const PARSE_RGB = {
  R: 0.2126,
  G: 0.7152,
  B: 0.0722
}

export const HEX_LENGTH = 7

export const TWENTY_PERCENT_ALPHA_HEX = 33
